<template>
  <div>
    <page-header
      :actions="actions"
      left-side-class="col-xl-4"
      :page="page"
      right-side-class="col-xl-8 align-items-end d-flex pb-2 justify-content-end"
    />

    <add-card
      v-if="showAddCard"
      :activate.sync="showAddCard"
      :card-statuses="catalog.status"
    />

    <separator class="my-3" />

    <filter-manager
      ref="attendanceFilterRef"
      v-model="filterModel"
      class="mb-4 filter-manager-extended"
      :display-advanced="true"
      :filters="filterManagerConfig"
      @search="onSearchHandler"
    />
    <separator class="my-3" text="Resultado de Tarjetas" />
    <custom-result-not-found v-if="result.data.length === 0" />
    <search-result
      :result-data="result"
      @do-search="getCardsData"
      @on-page-change="onPageChangeHandler"
    />
  </div>
</template>

<script>
import PageHeader from 'PageHeader';
import alertMixin from '@/mixins/alert.mixin';
import Separator from 'custom-separator';
import CustomResultNotFound from 'custom-result-not-found';
import SearchResult from './components/SearchResult';
import FilterManager from 'FilterManager';
import AddCard from './components/AddCard.vue';
import { getActiveRegions as _getActiveRegions } from '@/modules/shared/location.api.js';
import { getCardManagementStatus as _getCardManagementStatus } from '@/modules/shared/code.api.js';
import {
  getSearchResult as _getSearchResult,
  downloadCardDeliveryReport as _downloadCardDeliveryReport,
} from '@/modules/shared/cardHandling.api.js';
import moment from 'moment';
export default {
  name: 'MainCardHandling',
  components: {
    PageHeader,
    Separator,
    SearchResult,
    CustomResultNotFound,
    FilterManager,
    AddCard,
  },
  mixins: [alertMixin],
  data: () => ({
    page: {
      icon: 'far fa-credit-card',
      title: 'Manejo de Tarjetas',
      routes: ['Inicio', 'Becas', 'Manejo de Tarjetas'],
    },
    filterModel: {
      regionId: null,
      statusId: null,
      nameSSNSIE: '',
      createdDateFrom: null,
      createdDateTo: null,
      paymentJournalNumber: '',
      claim: null,
      pageIndex: 1,
      pageSize: 15,
    },
    catalog: {
      regions: [],
      status: [],
    },
    result: {
      data: [],
      pagination: {},
    },
    claimOptions: [
      {
        label: 'Si',
        value: true,
      },
      {
        label: 'No',
        value: false,
      },
    ],
    showAddCard: false,
  }),
  computed: {
    actions() {
      return [
        {
          name: 'Añadir Tarjeta',
          icon: 'fas fa-file-plus',
          variant: 'success',
          text: 'Añadir Tarjeta',
          visible: true,
          click: this.onAddCard,
        },
        {
          name: 'Informe para Entrega de Tarjetas',
          icon: 'far fa-download',
          variant: 'outline-success',
          text: 'Informe para Entrega de Tarjetas',
          visible: true,
          click: this.downloadCardDeliveryReport,
        },
      ];
    },
    filterManagerConfig() {
      return [
        {
          component: 'CustomDropDown',
          name: 'regionId',
          options: this.catalog.regions,
          placeholder: 'Seleccione región',
          fieldKey: 'id',
          class: 'col-md-4',
          fieldName: 'name',
          clearable: true,
        },
        {
          component: 'CustomDropDown',
          name: 'statusId',
          options: this.catalog.status,
          placeholder: 'Seleccione estatus',
          fieldKey: 'id',
          class: 'col-md-4',
          fieldName: 'name',
          clearable: true,
        },
        {
          component: 'CustomInput',
          name: 'nameSSNSIE',
          placeholder: 'Escribe Nombre, SSN o SIE',
          icon: 'fa fa-search color-orange',
          leftIcon: true,
        },
        {
          component: 'CustomDatePicker',
          name: 'createdDateFrom',
          placeholder: 'DD/MM/YYYY',
          icon: 'fa fa-search color-orange',
          classContainer: 'w-100',
          leftIcon: true,
          isAdvanced: true,
          maxDate: new Date(),
          class: 'col-md-3',
          label: 'Fecha de Creación (Desde):',
        },

        {
          component: 'CustomDatePicker',
          name: 'createdDateTo',
          placeholder: 'DD/MM/YYYY',
          icon: 'fa fa-search color-orange',
          leftIcon: true,
          classContainer: 'w-100',
          isAdvanced: true,
          class: 'col-md-3',
          minDate: moment(this.filterModel.createdDateFrom)
            .add(-1, 'days')
            .toDate(),
          maxDate: moment(new Date())
            .add(-1, 'days')
            .toDate(),
          label: 'Fecha de Creación (Hasta):',
        },
        {
          component: 'CustomDropDown',
          name: 'claim',
          options: this.claimOptions,
          fieldKey: 'value',
          class: 'col-md-3',
          fieldName: 'label',
          clearable: true,
          isAdvanced: true,
          label: 'Reclamación:',
          placeholder: 'No',
        },
        {
          component: 'CustomInput',
          name: 'paymentJournalNumber',
          icon: 'fa fa-search color-orange',
          leftIcon: true,
          classContainer: 'w-100',
          isAdvanced: true,
          class: 'col-md-3',
          label: 'Número de Jornal:',
          masked: true,
          maskType: 'Journal',
        },
      ];
    },
    filterPayload() {
      const filterModel = this.filterModel;
      return {
        regionId: filterModel.regionId?.id ?? null,
        statusId: filterModel.statusId?.id ?? null,
        nameSSNSIE: filterModel.nameSSNSIE,
        createdDateFrom: filterModel.createdDateFrom,
        createdDateTo: filterModel.createdDateTo,
        paymentJournalNumber: filterModel.paymentJournalNumber,
        claim: filterModel.claim?.value ?? null,
        pageIndex: 1,
        pageSize: 15,
      };
    },
  },
  mounted() {
    this.getCardsData();
    this.loadInitFilters();
  },
  methods: {
    async onAddCard() {
      this.showAddCard = true;
    },
    onCancelAddCard() {
      this.showAddCard = false;
    },
    async downloadCardDeliveryReport() {
      _downloadCardDeliveryReport(this.filterPayload);
    },
    async getCardsData(pageIndex = 1) {
      this.filterPayload.pageIndex = pageIndex;
      const { data: response } = await _getSearchResult(this.filterPayload);
      this.result = {
        data: response.data,
        pagination: {
          ...this.result.pagination,
          currentPage: response.currentPage,
          totalItemCount: response.totalItemCount,
          pageCount: response.pageCount,
          count: response.count,
          perPage: 15,
        },
      };
    },
    async loadInitFilters() {
      const regions = await _getActiveRegions();
      this.catalog.regions = regions.data;

      const status = await _getCardManagementStatus();
      this.catalog.status = status.data;
    },
    async onSearchHandler() {
      await this.getCardsData();
    },
    onPageChangeHandler(page) {
      this.getCardsData(page);
    },
  },
};
</script>
<style scoped></style>
